import { IconButton, useTheme } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';

const DialogTitleDefault = ({ children, onClose, ...other }) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    return (
        <DialogTitle sx={{ m: 0, p: 2,textAlign:'center' }} {...other}>
            {children}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: isDarkMode ? '#b0bec5' : '#64748b',
                    background: isDarkMode ? '#2d3a52' : '#f1f5f9',
                    width: 32,
                    height: 32,
                    '&:hover': {
                        background: isDarkMode ? '#3d4a62' : '#e2e8f0',
                        color: isDarkMode ? '#fff' : '#475569'
                    },
                    transition: 'all 0.2s ease'
                }}
            >
                <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>
        </DialogTitle>
    );
}
export default DialogTitleDefault